"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var core_1 = require("@material-ui/core");
var InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
var ErrorOutlineOutlined_1 = __importDefault(require("@material-ui/icons/ErrorOutlineOutlined"));
var ReportProblemOutlined_1 = __importDefault(require("@material-ui/icons/ReportProblemOutlined"));
var Button_1 = __importDefault(require("../Button/Button"));
var NotificationBar_css_1 = __importDefault(require("./NotificationBar-css"));
var NotificationBar = /** @class */ (function (_super) {
    __extends(NotificationBar, _super);
    function NotificationBar() {
        var _this = _super.call(this) || this;
        _this.handleClose = function (notificationObject, triggerAction) { return function (event, reason) {
            console.debug(event, reason);
            if (reason === "clickaway" && !notificationObject.enableClickAway) {
                return;
            }
            _this.setState({ showNotifications: false }, function () {
                if (notificationObject.actionMethod && triggerAction) {
                    notificationObject.actionMethod();
                }
            });
        }; };
        _this.showNext = function () {
            _this.setState(function (prevState) { return ({
                notifications: prevState.notifications.length <= 1
                    ? []
                    : prevState.notifications.slice(1),
                showNotifications: prevState.notifications.length > 1
            }); });
        };
        _this.componentDidMount = function () {
            if (_this.props.initialNotification) {
                _this.enqueueNotification(_this.props.initialNotification);
            }
        };
        _this.enqueueNotification = function (notification) {
            var notificationObj = {};
            if (typeof notification === "string") {
                notificationObj.message = notification;
            }
            else {
                notificationObj = __assign({}, notification);
            }
            _this.setState(function (prevState) { return ({
                notifications: __spreadArray(__spreadArray([], prevState.notifications), [notificationObj]),
                showNotifications: true
            }); });
        };
        _this.render = function () {
            console.debug("Notifications", _this.state.notifications);
            var notificationObject = _this.state.notifications[0];
            var hideDuration = 6000;
            if (Object.keys(_this.props).includes("autoHideDuration")) {
                hideDuration = _this.props.autoHideDuration;
            }
            if (notificationObject &&
                Object.keys(notificationObject).includes("autoHideDuration")) {
                hideDuration = notificationObject.autoHideDuration;
            }
            return _this.state.notifications.length ? (react_1.default.createElement(core_1.Snackbar, { style: NotificationBar_css_1.default["invosys-ui-NotificationBar"], anchorOrigin: __assign(__assign({ vertical: "top", horizontal: "center" }, (_this.props.anchorOrigin || {})), (notificationObject.anchorOrigin || {})), open: _this.state.showNotifications, autoHideDuration: hideDuration, onClose: _this.handleClose(notificationObject), TransitionProps: { onExited: _this.showNext }, message: react_1.default.createElement(core_1.Grid, { container: true, direction: "row", style: NotificationBar_css_1.default["invosys-ui-NotificationBar-messageWrapper"] },
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 2 },
                        notificationObject.type === "info" && (react_1.default.createElement(InfoOutlined_1.default, { style: { marginRight: "8px" } })),
                        notificationObject.type === "warning" && (react_1.default.createElement(ReportProblemOutlined_1.default, { style: { marginRight: "8px" } })),
                        notificationObject.type === "error" && (react_1.default.createElement(ErrorOutlineOutlined_1.default, { style: { marginRight: "8px" } }))),
                    react_1.default.createElement(core_1.Grid, { item: true, xs: 10 }, notificationObject.message)), action: react_1.default.createElement("div", { style: NotificationBar_css_1.default["invosys-ui-NotificationBar-actionWrapper"] },
                    react_1.default.createElement(Button_1.default, { color: "primary", size: "small", onClick: _this.handleClose(notificationObject, true) }, _this.state.notifications[0].actionLabel || "Hide")) })) : null;
        };
        _this.state = {
            notifications: [],
            showNotifications: false
        };
        return _this;
    }
    NotificationBar.defaultProps = {
        autoHideDuration: 6000,
        anchorOrigin: { vertical: "top", horizontal: "center" }
    };
    return NotificationBar;
}(react_1.default.Component));
NotificationBar.propTypes = {
    autoHideDuration: prop_types_1.default.number,
    anchorOrigin: prop_types_1.default.object,
    classes: prop_types_1.default.object,
    initialNotification: prop_types_1.default.object
};
exports.default = NotificationBar;
